<template lang="pug">
  header.header(:class="stickyHeaderClass")
    .sticky-mobile-bar
      button.hamburger.hamburger--3dy(
        type="button"
        :class="{ 'is-active': sidebar }"
        @click="toggleSidebar"
      )
        span.hamburger-box
          span.hamburger-inner
      ShoppingCart
  
    //.header-menu-wrap
      .container.header-top
          Menu#header-menu(k="header-menu" :max-depth="1")
          ShoppingCart.text-white
    .container.mx-auto.header-bottom
        .logo
          component(:is="logoWrap" v-bind="logoWrapProps")
            img(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
            img(v-else src="@/assets/weinankauf.svg")   
        Menu#main-menu(k="main-menu" :max-depth="2")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { trim } from '@/helpers';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart.vue';

export default {
    name: 'Header',
    data: () => ({
        lastScroll: 0,
        stickyHeaderClass: ''
    }),
    components: {
        Menu,
        ShoppingCart
    },
    computed: {
        logoWrap() {
            let tag = 'div';
            if (this.$route.path !== '/') {
                tag = 'a';
            }
            return tag;
        },
        logoWrapProps() {
            let props = {};
            if (this.$route.path !== '/') {
                props = { href: '/' };
            }
            return props;
        },
        image() {
            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            const fit = 'fit&h=160';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar'
        })
    },
    methods: {
        openSearch() {
            console.log('open search bar');
        },
        toggleSidebar() {
            this.updateSidebarVisibility(!this.sidebar);
        },

        updateStickyHeader() {
            const currentScroll = window.pageYOffset;

            const scrollUp = 'scroll-up';
            const scrollDown = 'scroll-down';

            if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
                this.stickyHeaderClass = scrollDown;
            } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
                this.stickyHeaderClass = scrollUp;
            }

            this.lastScroll = currentScroll;
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.updateStickyHeader);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateStickyHeader);
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  @apply flex justify-end flex-col bg-white border-b-4 border-solid
  border-color: $weinankauf-olive
  .header-menu-wrap
    @apply w-full hidden
    @screen lg
      background-color: $maisonvin-red-dark
      @apply block py-2
    .header-top
      @apply mx-auto flex justify-end

    #header-menu
      @apply hidden
      @screen lg
        @apply block
      ::v-deep ul
        & > li
          @apply inline-block border-0
          &.active .tree-item a
            @apply text-gray-500
          .tree-item > a
            @apply text-base font-medium transition duration-500 ease-in-out text-white px-2
            -webkit-appearance: none
            &:hover
              @apply text-gray-500

  .header-bottom
    @apply flex flex-col items-center
    .logo
      @apply w-full my-4
      max-width: 200px
      @screen sm
        @apply w-full my-8
        max-width: 220px
      @screen md
        max-width: 300px
    #main-menu
      @apply hidden
      @screen lg
        @apply block mt-1 mb-8
      &::v-deep
        ul
          &.tree-menu
            & > li
              transition: background-color .3s ease
              position: relative
              &.active > .tree-item > a:after,
              &.active.visible.hover > .tree-item > a:after
                transform: scaleX(1)

              &.visible.hover > .tree-item > a
                //color: $cc-blue
                &:after
                  transform: scaleX(1)

              &.visible.hover.has-children
                > .tree-item a
                  transform: scaleX(0)

              &:last-of-type > .tree-item a
                //margin-right: 0

              &:not(.full-width)
                position: relative
              & > .tree-item a
                @apply text-base font-medium mx-3 uppercase
                transition: color .15s ease, border-color .3s ease
                -webkit-appearance: none
                color: $maisonvin-red-dark
                &:after
                  @apply block absolute left-0 border-t-2 border-solid
                  border-color: $maisonvin-red-dark
                  transition: transform .3s ease-out,border-color .3s ease-out
                  bottom: -6px
                  margin-left: 10px
                  width: calc(100% - 20px)
                  transform: scaleX(0)
                  content: ''
                & > .active
                  color: $maisonvin-red-dark
              li
                width: 100%
                & > .tree-item a
                  @apply font-normal block max-w-md p-2 normal-case border-b border-solid m-0
                  background: rgba(255,243,215,0.9)
                  color: $weinankauf-wine
                  border-color: $weinankauf-olive
                  &:hover
                    color: $weinankauf-wine !important
                    background-color: rgba(197, 195, 137, 0.9)
                  &:after
                    transform: scaleX(0) !important
                &.hover
                  & > .tree-item a
                    color: #fff
        & > ul
          &.tree-menu
            & > li
              display: inline-block
              & > ul
                &.tree-menu
                  @apply absolute z-50 inline-block max-w-md left-0 shadow-sm
                  top: 60px
                  min-width: 350px
            ul ul
              @apply absolute top-0
              min-width: 350px
              margin-bottom: 9px
              right: 0

        .show-enter-active, .show-leave-active
          transition: opacity 0.3s ease, transform 0.3s ease
          transform-origin: left center
        .show-enter, .show-leave-to
          opacity: 0
          transform: translateY(6px)

  .sticky-mobile-bar
    backdrop-filter: blur(20px)
    transition: transform .15s linear
    z-index: 10
    color: $weinankauf-wine
    @screen md
      left: 98px
    @screen lg
      @apply hidden
    &.scroll-down
      transform: translateY(-54px)
    .hamburger
      @apply absolute
      top: 12px
      left: 0
      height: 53px
      padding: 15px
      .hamburger-inner
        background-color: $weinankauf-wine
        color: $weinankauf-wine
        &:before, &:after
           background-color: $weinankauf-wine
    .shopping-cart
      @apply absolute
      right: 20px
      top: 33px
      &::v-deep
        .price
          @apply hidden
          @screen sm
            @apply inline-block
</style>
